import styled from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
const gradientHeight = isMobileOnly ? 140 : 200;
export const Header = styled.div `
    width: 100%;
    height: ${gradientHeight}px;
    display: flex;
    align-items: flex-start;
    padding: 20px 48px 0px;
    justify-content: flex-start;
    align-items: flex-start;
    opacity: ${({ isSeeking }) => (isSeeking ? 0.2 : 1)};
    background-image: ${({ gradient }) => `linear-gradient(to bottom, ${gradient === null || gradient === void 0 ? void 0 : gradient.colors[0]}, ${gradient === null || gradient === void 0 ? void 0 : gradient.colors[1]})`};
`;
Header.displayName = 'Header';
//# sourceMappingURL=index.js.map